import { FC } from 'react';
import { Document, Font } from '@react-pdf/renderer';
import '../Pdf/fonts';
import { CurrencyCode } from 'further-types/lp/vehicle';
import {
  CapitalActionNoticeCommitmentData,
  CapitalActionNoticeCumulativeCapitalPositionData,
  CapitalActionNoticeData,
  CapitalActionNoticeTransactionBreakdownData,
  CapitalActionNoticeUnfundedCommitmentBalance,
  PaymentDetails,
} from './types';
import PageOne from './PageOne';
import PageTwo from './PageTwo';
import PageThree from './PageThree';

Font.registerHyphenationCallback((word) => [word]);

export type CapitalActionNoticeProps = {
  firmLogoUrl?: string;
  firmWhiteBackgroundLogoUrl?: string;
  firmContactEmail: string;
  firmDomain: string;
  currencyLcy: CurrencyCode;
  paymentRequired: boolean;
  totalNetCapitalCalledLcy: number;
  palette: {
    firmBackgroundColor: string;
    backgroundContrastColor: string;
    backgroundSubtleContrastColor: string;
    firmSecondaryColor: string;
  };
  paymentDetails: PaymentDetails;
  capitalActionNotice: CapitalActionNoticeData;
  commitment: CapitalActionNoticeCommitmentData;
  unfundedCommitmentBalance: CapitalActionNoticeUnfundedCommitmentBalance;
  transactionBreakdown: CapitalActionNoticeTransactionBreakdownData;
  cumulativeCapitalPosition: CapitalActionNoticeCumulativeCapitalPositionData;
};

const CapitalActionNotice: FC<CapitalActionNoticeProps> = ({
  currencyLcy,
  firmWhiteBackgroundLogoUrl,
  firmContactEmail,
  cumulativeCapitalPosition,
  commitment,
  unfundedCommitmentBalance,
  transactionBreakdown,
  ...props
}) => {
  const { palette } = props;
  return (
    <Document title="Capital call notice">
      <PageOne currencyLcy={currencyLcy} {...props} />
      <PageTwo
        commitment={commitment}
        unfundedCommitmentBalance={unfundedCommitmentBalance}
        transactionBreakdown={transactionBreakdown}
        currencyLcy={currencyLcy}
      />
      <PageThree
        cumulativeCapitalPositionData={cumulativeCapitalPosition}
        firmSecondaryColor={palette.firmSecondaryColor}
        contactEmail={firmContactEmail}
        whiteBackgroundLogoUrl={firmWhiteBackgroundLogoUrl}
        currencyLcy={currencyLcy}
      />
    </Document>
  );
};

export default CapitalActionNotice;
